import React from "react";
import { Link } from "react-router-dom";

const CoreComponent10 = ({comp10}) => {
  return (
   <div className=" mart  container ">
     {comp10.map((val,i)=>(
          
          <div key={i} className=" mx-auto pt-60  pb-60 px-md-5 padt padb marb mart  rounded-5 mb-80 text-center" style={{background:'#f4fafaff'}} >
        <h2 className="h2-heading fw-semibold fs-2 text-black lh-sm">{val.title}
        </h2>
        <p className="  fs-2 text-black lh-sm">{val.desc}</p>
        <Link to="/request-quote">
        <button className="h1-para btn-gradient text-white  text-center m-auto mt-4 px-4 py-2 rounded-5 fw-less">
          Connect With Us
        </button>
        </Link>
      </div>
      ))}
   </div>
  );
};

export default CoreComponent10;
